import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'error-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss', '../signup-errors.component.scss']
})
export class ErrorRequestsComponent implements OnInit {
  hostingUrl = '';

  constructor() {
  }

  ngOnInit() {
    this.hostingUrl = window['ENDPOINTS'].hosting;
  }

}
